// extracted by mini-css-extract-plugin
module.exports = {"ST_recContainer":"RecTrendingCars-module__ST_recContainer","ST_recommendations":"RecTrendingCars-module__ST_recommendations","ST_singleRec":"RecTrendingCars-module__ST_singleRec"};